import { render, staticRenderFns } from "./ModalUserEventDetails.vue?vue&type=template&id=c3dcc8d8&scoped=true&"
import script from "./ModalUserEventDetails.vue?vue&type=script&lang=ts&"
export * from "./ModalUserEventDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dcc8d8",
  null
  
)

export default component.exports